import { env } from '@config/env';
import type { JoinCommunityConfig } from '@config/env/types';

/** Fully-resolved join copy — every field defined (env overrides defaults). */
export type ResolvedJoinConfig = Required<Omit<JoinCommunityConfig, 'enabled'>> & {
  enabled: boolean;
};

const DEFAULTS: ResolvedJoinConfig = {
  enabled: false,
  entryLabel: 'Join a community',
  entityName: 'community',
  entityPlural: 'communities',
  title: 'Join a community',
  subtitle: 'Find another community and request to join it.',
  searchTitle: 'Find your community',
  searchSubtitle: 'Search for the community you want to join.',
  searchPlaceholder: 'Search communities…',
  detailsTitle: 'Your details',
  detailsSubtitle: 'Confirm your details to request access.',
  submitLabel: 'Request to join',
  termsLabel: 'I accept the terms and conditions',
  successTitle: 'Request submitted',
  successMessage:
    "Your request to join has been sent. You'll be notified once the community reviews it.",
  pendingTitle: 'Request pending',
  pendingMessage: 'You already have a pending request to join this community.',
};

/** Merge the build's `joinCommunity` config over the defaults. */
export function joinConfig(): ResolvedJoinConfig {
  const c = env.joinCommunity ?? {};
  return {
    enabled: c.enabled ?? DEFAULTS.enabled,
    entryLabel: c.entryLabel ?? DEFAULTS.entryLabel,
    entityName: c.entityName ?? DEFAULTS.entityName,
    entityPlural: c.entityPlural ?? DEFAULTS.entityPlural,
    title: c.title ?? DEFAULTS.title,
    subtitle: c.subtitle ?? DEFAULTS.subtitle,
    searchTitle: c.searchTitle ?? DEFAULTS.searchTitle,
    searchSubtitle: c.searchSubtitle ?? DEFAULTS.searchSubtitle,
    searchPlaceholder: c.searchPlaceholder ?? DEFAULTS.searchPlaceholder,
    detailsTitle: c.detailsTitle ?? DEFAULTS.detailsTitle,
    detailsSubtitle: c.detailsSubtitle ?? DEFAULTS.detailsSubtitle,
    submitLabel: c.submitLabel ?? DEFAULTS.submitLabel,
    termsLabel: c.termsLabel ?? DEFAULTS.termsLabel,
    successTitle: c.successTitle ?? DEFAULTS.successTitle,
    successMessage: c.successMessage ?? DEFAULTS.successMessage,
    pendingTitle: c.pendingTitle ?? DEFAULTS.pendingTitle,
    pendingMessage: c.pendingMessage ?? DEFAULTS.pendingMessage,
  };
}
